import { BaseBlockModel, defineBlockSchema } from '@blocksuite/store';
import { selectable } from '../_common/edgeless/mixin/edgeless-selectable.js';
import { FRAME_BATCH } from '../surface-block/batch.js';
import { Bound, } from '../surface-block/index.js';
export const FrameBlockSchema = defineBlockSchema({
    flavour: 'affine:frame',
    props: (internal) => ({
        title: internal.Text(),
        background: '--affine-palette-transparent',
        xywh: `[0,0,100,100]`,
        index: 'a0',
    }),
    metadata: {
        version: 1,
        role: 'content',
        parent: ['affine:surface'],
        children: [],
    },
    toModel: () => {
        return new FrameBlockModel();
    },
});
export class FrameBlockModel extends selectable(BaseBlockModel) {
    constructor() {
        super(...arguments);
        this.batch = FRAME_BATCH;
    }
    hitTest(x, y, _) {
        const bound = Bound.deserialize(this.xywh);
        return bound.isPointNearBound([x, y], 5);
    }
    boxSelect(seclectedBound) {
        const bound = Bound.deserialize(this.xywh);
        return (bound.isIntersectWithBound(seclectedBound) ||
            seclectedBound.contains(bound));
    }
}
//# sourceMappingURL=frame-model.js.map